import PaymentButton from 'components/Sales/Invoices/PaymentButton'
import React, { useState } from 'react'
import checkboxHOC from 'react-table-v6/lib/hoc/selectTable'
import CustomTable from '../../../elements/Table/CustomTable'
import { Button, Tag } from 'antd'
import DateCell from '../../../elements/Table/Cells/DateCell'
import StatusCell from '../../../elements/Table/Cells/StatusCell'
import moment from 'moment'
import DateFilter, { dateFilterMethod } from '../../../elements/Table/Filters/Date'
import { Link, withRouter } from 'react-router-dom'
import StatusFilter, { statusFilterMethod } from '../../../components/Sales/Enquiries/TableComponents/StatusFilter'
import { streamUrl } from '../../../variables'
import IconText from '../../../elements/IconText'
import Authentication from '../../../modules/Authentication'

const CheckboxTable = checkboxHOC(CustomTable)

function List(props) {
  const {
    list,
    fetch,
    fetching,
    selectAll,
    isSelected,
    toggleSelection,
    toggleAll,
    tableRef,
    selection,
    selectionData,
  } = props

  console.log({ selection, selectionData })

  const [filtered, setFiltered] = useState([{ id: 'status', value: 'active' }])
  const [count, setCount] = useState(0) // weired bug that react only fire render with this
  const auth = new Authentication()

  const checkboxProps = {
    selectType: 'checkbox',
    selectAll,
    isSelected,
    toggleSelection,
    toggleAll,
  }
  const columns = [
    {
      Header: 'MAC',
      accessor: 'code',
      width: 100,
      Cell: ({ value, original }) => (
        <Link
          to={{
            pathname: `/clients/enquiries/${original._key}/update`,
          }}>
          {value}
        </Link>
      ),
    },
    { Header: 'Enquirer', accessor: 'enquirer.fn', width: 300, alignment: 'left' },
    { Header: 'Type', accessor: 'enquiryType', hideable: true, hideDefault: true },
    {
      Header: 'Reference',
      accessor: 'reference.no',
      hideable: true,
      alignment: 'left',
      hideDefault: false,
    },
    {
      Header: 'CPO #',
      accessor: 'cpo.no',
      hideable: true,
      alignment: 'left',
      hideDefault: true,
    },
    {
      Header: 'Tracking Carrier',
      accessor: 'delivery.carrier',
      hideable: true,
      alignment: 'left',
      hideDefault: true,
    },
    {
      Header: 'Tracking no',
      accessor: 'delivery.trackingNumber',
      hideable: true,
      alignment: 'left',
      hideDefault: true,
    },
    {
      Header: 'Delivery',
      accessor: 'delivery.address.label',
      hideable: true,
      alignment: 'left',
      hideDefault: true,
    },
    {
      Header: 'Date',
      accessor: 'date',
      Cell: DateCell,
      hideable: true,
      hideDefault: true,
    },
    { Header: 'Title', accessor: 'title', alignment: 'left', hideable: true, hideDefault: false, width: 350 },
    {
      Header: 'Response Due',
      accessor: 'due',
      Cell: DateCell,
      filterMethod: dateFilterMethod,
      Filter: DateFilter,
    },
    {
      Header: 'Follow up Date',
      accessor: 'followupDate',
      Cell: DateCell,
      filterMethod: dateFilterMethod,
      Filter: DateFilter,
    },
    {
      Header: 'Response Type',
      accessor: 'responseType',
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'Company',
      accessor: 'company.fn',
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'Center',
      accessor: 'center.name',
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'Assigned To',
      accessor: 'assignedTo.fn',
      hideable: true,
      hideDefault: false,
    },
    {
      Header: 'Status',
      accessor: 'status',
      Cell: StatusCell,
      filterMethod: statusFilterMethod,
      Filter: StatusFilter,
      /*filterMethod: (filter, row) => filter.value === row[filter.id],
      Filter: ({onChange, filter}) => (
        <EnquiryStatusSelect
          onChange={value => onChange(value)}
          value={filter && filter.value}
          style={{width: '100%'}}
        />
      ),*/
    },
    {
      Header: 'Summary PDF',
      accessor: '_key',
      Cell: ({ value }) =>
        value && (
          <a
            target={'_blank'}
            href={`${streamUrl}pdf/enquiries/${value}/summary?access_token=${auth.getAccessToken()}`}>
            <IconText text={'PDF preview'} type={'file-pdf'} />
          </a>
        ),
      hideable: true,
      hideDefault: false,
    },
  ]

  function onFilteredChangeCustom(value, accessor) {
    let newFiltered = filtered
    let insertNewFilter = 1
    value = value || ''
    if (newFiltered.length > 0) {
      newFiltered.forEach((filter, i) => {
        if (filter['id'] === accessor) {
          if (value === '' || !value.length) newFiltered.splice(i, 1)
          else filter['value'] = value
          insertNewFilter = 0
        }
      })
    }
    if (insertNewFilter) {
      newFiltered.push({ id: accessor, value: value })
    }
    setCount(count + 1) // and this one as well
    console.log({ newFiltered })
    setFiltered(newFiltered)
  }

  return (
    <CheckboxTable
      {...checkboxProps}
      withRef={tableRef}
      data={list}
      defaultPageSize={20}
      isFilterable={true}
      fetching={fetching}
      show={{ extraColumns: true }}
      fetch={fetch}
      CreateButton={() => (
        <Button
          type={'primary'}
          size="small"
          icon={'plus'}
          onClick={() =>
            props.history.push({
              pathname: '/clients/enquiries/new/',
            })
          }>
          New
        </Button>
      )}
      ExtraOptionsButtons={() => (
        <>
          <Tag
            onClick={() => {
              onFilteredChangeCustom([moment(), moment()], 'due')
            }}
            style={{ marginRight: 10 }}
            color="magenta">
            Due Today
          </Tag>
          <Tag
            onClick={() => {
              onFilteredChangeCustom([moment().startOf('w'), moment().endOf('w')], 'due')
            }}
            style={{ marginRight: 10 }}
            color="blue">
            Due This Week
          </Tag>
          <Tag
            onClick={() => {
              onFilteredChangeCustom([moment().startOf('M'), moment().endOf('M')], 'due')
            }}
            style={{ marginRight: 10 }}
            color="geekblue">
            Due This Month
          </Tag>
        </>
      )}
      onFilteredChange={(filtered, column, value) => {
        onFilteredChangeCustom(value, column.id || column.accessor)
      }}
      filtered={filtered}
      columns={columns}
    />
  )
}

List.propTypes = {}
List.defaultProps = {}

export default withRouter(List)
